import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class reportIssueSummary
 */
import path from 'path';
import { createHashHistory } from 'history';
import React, { Component } from 'react';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'underscore';
import { Row, Col, Card, Button, CardBody, CardHeader } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
import PopoverButton from '../common/controls/popoverButton';
import routeHelper from '../common/classes/routeHelper';
import { getReportNumber } from './reportSelectors';
const hashHistory = createHashHistory();
const buildSection = (title, sections) => {
  const jsx = /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, /*#__PURE__*/React.createElement("h4", {
    style: {
      marginBottom: '0'
    }
  }, title, ":"), sections.map(section => /*#__PURE__*/React.createElement("span", {
    key: section.name,
    className: "t-ris-".concat(kebabCase(title), "-").concat(kebabCase(section.name))
  }, "".concat(section.values.length, " ").concat(section.name), /*#__PURE__*/React.createElement("br", null))));
  return jsx;
};
const getIssueFromReport = report => {
  let issues = [];
  issues = _.sortBy(_.uniq(report.issueObjects), 'label');
  return issues;
};
const getIssuesByIdentifier = (issues, key, identifier) => {
  const filtered = _.filter(issues, issue => {
    if (issue[key] && issue[key].identifier) {
      return issue[key].identifier === identifier;
    }
    return false;
  });
  return filtered;
};
const byIssueSeverity = issues => {
  const high = getIssuesByIdentifier(issues, 'IssueSeverity', 'high');
  const med = getIssuesByIdentifier(issues, 'IssueSeverity', 'medium');
  const low = getIssuesByIdentifier(issues, 'IssueSeverity', 'low');
  const sections = [{
    name: 'High',
    values: high
  }, {
    name: 'Medium',
    values: med
  }, {
    name: 'Low',
    values: low
  }];
  return buildSection('Severity', sections);
};
const byIssueStatus = issues => {
  const open = getIssuesByIdentifier(issues, 'IssueStatus', 'open');
  const inR = getIssuesByIdentifier(issues, 'IssueStatus', 'inReview');
  const rev = getIssuesByIdentifier(issues, 'IssueStatus', 'reviewed');
  const closed = getIssuesByIdentifier(issues, 'IssueStatus', 'closed');
  const sections = [{
    name: 'Open',
    values: open
  }, {
    name: 'In Review',
    values: inR
  }, {
    name: 'Reviewed',
    values: rev
  }, {
    name: 'Closed',
    values: closed
  }];
  return buildSection('Status', sections);
};
class ReportIssueSummary extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    const _this$props = this.props,
      indexByReport = _this$props.issueActions.indexByReport,
      issueIndexQuery = _this$props.issueIndexQuery,
      report = _this$props.report;
    const reportName = getReportNumber(report);
    indexByReport(report.id, reportName, issueIndexQuery);
    routeHelper.updateURL('/issues');
  }
  render() {
    const _this$props2 = this.props,
      noURL = _this$props2.noURL,
      report = _this$props2.report;
    const handleClick = this.handleClick;
    const issues = getIssueFromReport(report);
    const className = "float-md-right t-ris-button".concat(!issues.length ? '-disabled' : '');

    // Default to counting, change when report data is returned from the server
    let title = 'Counting Issues...';

    // The report is an empty object (refresh) or a basic object (link from file
    // cabinet) until data is returned from the server with `Entity`

    if (noURL || report && report.signedURL) {
      // Only reports with associated documents will have reportDocumentObjects
      if (report.reportDocumentObjects && report.reportDocumentObjects.length > 0) {
        title = "".concat(issues.length, " Total Issues");
      } else {
        // Not possible to have associated issues if no associated documents
        title = 'No documents associated with this report';
      }
    }
    const severitySection = byIssueSeverity(issues);
    const statusSection = byIssueStatus(issues);
    let maxLength = 0;
    let documents = report.reportDocumentObjects;
    const handleDocumentClick = document => {
      const url = path.join('/issues/detailView', document.id);
      hashHistory.push(url);
    };
    if (documents) {
      documents = documents.map(doc => {
        maxLength = Math.max(maxLength, doc.displayName ? doc.displayName.length : 0);
        return _objectSpread(_objectSpread({}, doc), {}, {
          name: doc.displayName
        });
      });
      /**
      * There are two keys we need to sort on here.  First we sort by
      * appCreated on the reportDocument, the second key is the report
      * document id
      */
      documents = documents.sort((left, right) => {
        const diff = moment.utc(left.appCreated).diff(moment.utc(right.appCreated));
        if (diff !== 0) {
          return diff;
        }
        if (left.id < right.id) {
          return -1;
        }
        if (left.id > right.id) {
          return 1;
        }
        return 0;
      });
    }
    return /*#__PURE__*/React.createElement(Card, {
      className: "t-ris-card"
    }, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading-tight"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'left',
        minWidth: 70
      }
    }, /*#__PURE__*/React.createElement(Button, {
      block: true,
      className: className,
      disabled: !issues.length,
      onClick: handleClick
    }, "View")), /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'right'
      }
    }, /*#__PURE__*/React.createElement(PopoverButton, {
      enabled: typeof documents !== 'undefined' && documents.length !== 0,
      width: maxLength * 10,
      onSelect: handleDocumentClick,
      list: documents || [],
      testingIdentifier: "documents-button",
      title: "Documents",
      header: "Documents"
    }))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("h4", {
      className: "t-ris-total"
    }, title), issues.length ? severitySection : undefined, issues.length ? statusSection : undefined))));
  }
}
ReportIssueSummary.defaultProps = {
  noURL: false
};
ReportIssueSummary.propTypes = {
  noURL: PropTypes.bool,
  report: PropTypes.shape({
    id: PropTypes.string,
    reportNumber: PropTypes.number,
    reportType: PropTypes.shape({
      name: PropTypes.string
    }),
    signedURL: PropTypes.string,
    reportDocumentObjects: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  issueActions: PropTypes.shape({
    indexByReport: PropTypes.func
  }).isRequired,
  issueIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired
};
export { ReportIssueSummary as TestReportIssueSummary };
export default entityComposition(ReportIssueSummary, [], {
  issueIndexQuery: state => state.issue.indexQuery,
  report: state => state.report.active
}, ['issue']);